import sortBy from 'lodash/sortBy'
import D2C_ProviderHosting from './Hosting'
import store from '@/store'

class D2C_ProviderDO extends D2C_ProviderHosting {
  static objectType = 'providerType'
  static active = true
  static order = 11
  static providerType = 'DO'
  static providerTitle = 'DigitalOcean'
  static helpLink = 'https://docs.d2c.io/providers/cloud-providers/#digitalocean'
  static referal = 'If you don\'t have a DO account you can register with <a href="https://m.do.co/c/840a93a4ff3f" target="_blank">this link</a> and get $100 in credit over 60 days.'
  static oauth = true
  static fields = {
    ...D2C_ProviderHosting.fields,
    apiToken: {
      default: '',
      label: 'Token',
      path: 'auth.apiToken',
      required: true,
      validate(value) {
        return /^[a-z0-9]{64}$/.test(value) ? null : 'Must contain 64 letters or numbers'
      },
      creating: {},
      updating: {
        autoselect: true,
      },
    },
    refreshToken: {
      default: '',
      hidden: true,
      path: 'auth.refreshToken',
      required: false,
      validate() {
        return null
      },
      creating: {},
      updating: {},
    },
  }
  static get _instances() {
    const order = ['s', 'm', 'c']
    return sortBy(store.getters.instances.filter(instance => instance.providerType === this.providerType), [i => order.indexOf(i.id.substr(0, 1)), 'memory', 'cores', 'storageSize'])
  }
}

export default D2C_ProviderDO
